import styled from 'styled-components';
import ButtonImplementation from './implementation/ButtonImplementation';
/*
const ButtonImplementationAni = (props: IButtonProps): any => {
  const theme = React.useContext(ThemeContext);
  console.log('PROPS', props, theme);

  // 1. resolve active theme
  // 2. if active theme contains no animations => nothing to do
  // 3. if active theme contains animations =>

  return (
    <AnimationComponent component={ButtonImplementation} componentProps={props}>
    </AnimationComponent>
  );
};
*/
var ButtonComponent = styled(ButtonImplementation).attrs(function (props) {
    props.disabled = true;
})(function (props) {
    var styleObject = props.theme.coreThemes.button.getStyleObjectBuilder(props, 'margin', 'padding', 'border', 'backgroundColor', 'height', 'width', 'font')
        .withBaseStyle({
        justifyContent: 'center',
        alignItems: 'center'
    })
        .withWebStyle({
        cursor: 'pointer'
    })
        .withCustomStyle(props.customStyle)
        .build();
    return styleObject;
});
export default ButtonComponent;
//# sourceMappingURL=ButtonComponent.js.map